'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BestSeller = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _pcSlateTools = require('./../../process/pc-slate-tools');

var _ShopifySection = require('./../ShopifySection');

var _QuantitySelector = require('./../../objects/quantity/QuantitySelector');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *  Recently Viewed Peoducts
 *
 *
 *  Version:
 *    1.0.0 - 2020/08/11
 */

var CONTAINER_SELECTOR = '[data-recently-viewed]';
var THUMBNAIL_TEMPLATE = '[data-recently-viewed-thumbnail]';
var CAROUSEL_SELECTOR = '[data-recently-viewed-loop]';
var CART_ADD_BUTTON = '[data-add-to-cart-button]';
var CLASS_DISABLED = 'is-disabled';
var BUTTON_MINUS = '[data-quantity-selector-minus]';
var BUTTON_PLUS = '[data-quantity-selector-plus]';
var QUANTITY_BOX = '[data-quantity-selector-field]';

var BestSeller = exports.BestSeller = function () {
  function BestSeller(container) {
    var _this = this;

    (0, _classCallCheck3.default)(this, BestSeller);


    container.on('click', CART_ADD_BUTTON, function (e) {
      return _this.onAddClick(e);
    });
    container.on('click', BUTTON_MINUS, function (e) {
      return _this.qtyProcess(e, 0);
    });
    container.on('click', BUTTON_PLUS, function (e) {
      return _this.qtyProcess(e, 1);
    });
    container.on('change', QUANTITY_BOX, function (e) {
      return _this.onChangeItem(e);
    });
    //new QuantitySelector(container);
    //this.QtyChange = new QuantitySelector(container);
    /*$('.c-best-sellers .o-product-thumbnail').each(function (index, e) {
    	//console.log(e);
    	//console.log($(this).closest('[data-product-thumbnail]'));
    	new QuantitySelector($(this).closest('[data-product-thumbnail]'));
    });*/
  }

  (0, _createClass3.default)(BestSeller, [{
    key: 'qtyProcess',
    value: function qtyProcess(e, t) {
      e.preventDefault();
      e.stopPropagation();
      var self = (0, _jquery2.default)(e.currentTarget);
      new _QuantitySelector.QuantitySelector(self.closest('[data-product-thumbnail]'));
      /*let max = self.closest('[data-quantity-selector]').data('max');console.log(max);
      let qObj = self.closest('[data-quantity-selector]').find('[data-quantity-selector]');
      var qty = qObj.val();
      if(t == 0) {
      	if(qty>1) qty--; else {self.attr("disabled", true);return false;}
      self.closest(BUTTON_PLUS).attr("disabled", false);}
      else {
      	if(max == null || qty < max) qty++;
      	else  {self.attr("disabled", true);return false;}
      self.closest(BUTTON_MINUS).attr("disabled", false);
      }
      qObj.val(qty);*/
      //updateCart(qObj.data('index'), qty);
      //$(document).on(ON_CART_FINISHED, () => this.onUpdateItem(self, qObj.data('index')));
    }
  }, {
    key: 'onChangeItem',
    value: function onChangeItem(e) {
      var self = (0, _jquery2.default)(e.currentTarget);
      var max = self.closest('[data-quantity-selector]').data('max');
      var q = self.val();
      //self.closest("div").find(".is-minus").attr("disabled", false);self.closest("div").find(".is-plus").attr("disabled", false);
      //if(q <= 1) {self.closest("div").find(".is-minus").attr("disabled", true);q = 1;self.val(q);}
      //if(max != null && q >= max) {self.closest("div").find(".is-plus").attr("disabled", true);q=max;self.val(q);}
    }
  }, {
    key: 'updateButton',
    value: function updateButton(o, id) {
      o.html('ADD TO CART');
    }
  }, {
    key: 'onAddClick',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(e) {
        var _this2 = this;

        var self, id, qty, tiers;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();
                e.stopPropagation();
                self = (0, _jquery2.default)(e.currentTarget);
                id = self.closest('[data-product-thumbnail]').data('variant-id');
                qty = self.closest('[data-product-thumbnail-add-to-cart]').find('[data-quantity-selector-field]').val();
                console.log(qty);
                tiers = JSON.parse(self.closest('[data-product-thumbnail]').find('[data-pricing-tiers]').html());
                console.log(tiers);

                if (!self.hasClass(CLASS_DISABLED)) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt('return');

              case 10:
                _context.prev = 10;

                self.html('Adding...');
                _context.next = 14;
                return (0, _pcSlateTools.addToCart)(id, qty, tiers);

              case 14:
                //this.wasAdded = true;//This will tell our button to temporarily display the "Was added" text
                (0, _jquery2.default)('[data-show-cart-drawer]').click();
                _context.next = 23;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](10);

                console.error(_context.t0);
                self.html('Add to Cart');
                if (_context.t0.description) alert(_context.t0.description);
                return _context.abrupt('return');

              case 23:

                self.html('Added!');
                setTimeout(function () {
                  return _this2.updateButton(self, id);
                }, 1000);

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[10, 17]]);
      }));

      function onAddClick(_x) {
        return _ref.apply(this, arguments);
      }

      return onAddClick;
    }()
  }]);
  return BestSeller;
}();